module.exports = __webpack_public_path__ + "40aa0699fd035f3b5b9992189c462394.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/backgrounds/bgr_2.jpg
// module id = 830
// module chunks = 0